import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetAllPaycardsRequestSchema,
  TGetAllPaycardsResponseSchema,
} from "./getAllPaycards.schema";

export const getAllPaycards = (axios: IAxiosInstance) => {
  return async (params: TGetAllPaycardsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetAllPaycardsResponseSchema>
    >(`/api/pay-cards`, { params });

    return response.data;
  };
};
